var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHistoryFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 5.25C45.9973 5.25 57.75 17.0025 57.75 31.5C57.75 45.9973 45.9973 57.75 31.5 57.75C17.0025 57.75 5.25 45.9973 5.25 31.5H10.5C10.5 43.098 19.902 52.5 31.5 52.5C43.098 52.5 52.5 43.098 52.5 31.5C52.5 19.902 43.098 10.5 31.5 10.5C25.0324 10.5 19.2476 13.4238 15.3954 18.0218L21 23.625H5.25V7.875L11.6722 14.297C16.4851 8.75461 23.5833 5.25 31.5 5.25ZM34.125 18.375L34.1245 30.4106L42.6368 38.9245L38.9245 42.6368L28.8745 32.5841L28.875 18.375H34.125Z",
    fill: "#BFD6D2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHistoryFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/history-fill.89b2cee2.svg";
export { ForwardRef as ReactComponent };